import type { ReactNode } from 'react';
import {
  NavigationMenuItem,
  NavigationMenuLink,
} from '../../components/ui/navigation-menu';
import { cn } from '../../lib/utils';

export function NavbarButton({
  icon,
  ariaLabel,
  onClick,
  className,
}: {
  icon: ReactNode;
  ariaLabel: string;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <NavigationMenuItem className="px-1">
      <NavigationMenuLink
        render={
          <button
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            className={cn('flex items-center justify-center', className)}
          >
            {icon}
          </button>
        }
      />
    </NavigationMenuItem>
  );
}
